<template>
  <div class="page-loading" v-if="isLoading">
    <font-awesome-icon :icon="['fad', 'spinner-third']" spin />
  </div>

  <div class="container-fluid">
    <header class="main-header">
      <h1 class="main-title">Gebruikers</h1>
    </header>

    <form @submit.prevent="formSubmit">
         <div class="col-12">
            <div class="card gebruikers-beheer">
            <div class="card-body">
                <h5>Beheer gebruikers</h5>
                <div class="form-group">
                <div class="input-group">
                    <select
                    class="form-select"
                    name="addToUserRolesName"
                    v-model="addToUserRolesId"
                    >
                    <option disabled selected value="">Kies gebruiker om toe te voegen</option>
                    <option
                        v-for="user in nonAddedUsers"
                        :key="user.userId"
                        :value="user.userId"
                    >
                        {{ user.firstName }} {{ user.lastName }} {{ user.isDisabled ? '(Uitgeschakeld)': '' }}
                    </option>
                    </select>
                    <button
                    type="button"
                    class="btn btn-secondary"
                    @click="addToUserList"
                    >
                    <font-awesome-icon :icon="['far', 'plus']" />
                    </button>
                </div>
                </div>

                <div class="table-scroll-container">
                  <div class="scroll-indicators" v-if="canScrollLeft || canScrollRight">
                    <button
                      type="button"
                      class="scroll-indicator"
                      :class="{ 'scroll-indicator-hidden': !canScrollLeft }"
                      @click="scrollTable('left')"
                    >
                      &#8249;
                    </button>
                    <span class="scroll-hint">Scroll voor meer poorten</span>
                    <button
                      type="button"
                      class="scroll-indicator"
                      :class="{ 'scroll-indicator-hidden': !canScrollRight }"
                      @click="scrollTable('right')"
                    >
                      &#8250;
                    </button>
                  </div>
                  <div class="table-responsive user-tabel-wrapper" ref="tableWrapper" @scroll="updateScrollIndicators">
                  <table class="table user-tabel">
                    <thead>
                    <tr>
                      <th scope="col" class="sticky-column sticky-column-left gebruiker-kolom">Gebruiker</th>
                      <th
                        v-for="gate in gates"
                        :key="gate.id"
                        scope="col"
                        class="text-center poort-kolom"
                        :title="gate.name"
                      >
                        <router-link
                          class="poort-label poort-link"
                          :to="{ name: 'GateDetail', params: { id: gate.id } }"
                        >
                          {{ gate.name }}
                        </router-link>
                      </th>
                      <th scope="col" class="sticky-column sticky-column-right role-header">Rol</th>
                      <th scope="col" class="sticky-column sticky-column-right text-end verwijderen-header">Verwijderen</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="user in userRoles"
                      :key="user.userId"
                      :class="{ 'list-group-item-disabled': user.isDisabled || user.isSelf }"
                    >
                      <td class="sticky-column sticky-column-left gebruiker-kolom">
                        {{ user.firstName }} {{ user.lastName }} {{ user.isDisabled ? '(Uitgeschakeld)' : '' }}
                      </td>
                      <td
                        v-for="gate in gates"
                        :key="`${user.userId}-${gate.id}`"
                        class="text-center poort-cel"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :checked="isGateLinked(user.userId, gate.id)"
                          :disabled="user.isSelf"
                          @change="toggleGateLink(user.userId, gate.id, $event.target.checked)"
                        />
                      </td>
                      <td class="sticky-column sticky-column-right rol-kolom">
                        <select
                          class="form-select"
                          name="sequence"
                          v-model="user.role"
                          :disabled="user.isSelf"
                          :style="{ 'background-image': user.isSelf ? 'none' : '' }"
                        >
                          <option value="Member" selected>App-gebruiker</option>
                          <option value="Admin">Beheerder</option>
                        </select>
                      </td>
                      <td class="sticky-column sticky-column-right text-end verwijderen-kolom">
                        <button
                          type="button"
                          class="btn text-danger"
                          @click="removeFromUserList(user.userId)"
                          :disabled="user.isSelf"
                          :style="{ 'visibility': user.isSelf ? 'hidden' : 'visible' }"
                        >
                          <font-awesome-icon :icon="['far', 'times']" />
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
            </div>
            </div>
            <div class="actions">
              <button type="button" @click="getData()" class="btn btn-gray">Annuleren</button>
              <button type="submit" class="btn btn-primary-dark ms-3">Opslaan</button>
            </div>
        </div>
    </form>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "Roles",
  data() {
    return {
        isLoading: false,
        userRoles: [],
        nonAddedUsers: [],
        addToUserRolesId: "",
        gates: [],
        userGateLinksByUserId: {},
        canScrollLeft: false,
        canScrollRight: false
    }
  },

  methods: {
    updateScrollIndicators() {
      const wrapper = this.$refs.tableWrapper;
      if (!wrapper) return;
      this.canScrollLeft = wrapper.scrollLeft > 0;
      this.canScrollRight = wrapper.scrollLeft + wrapper.clientWidth < wrapper.scrollWidth - 1;
    },

    scrollTable(direction) {
      const wrapper = this.$refs.tableWrapper;
      if (!wrapper) return;
      const scrollAmount = 200;
      wrapper.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    },

    normalizeGate(gate) {
      if (typeof gate === "string") {
        return {
          id: gate,
          name: gate
        };
      }

      const name = gate.abbreviation ?? gate.gateId ?? '';
      const id = gate.gateId ?? "";

      return {
        id,
        name
      };
    },

    hydrateGateLinks(users) {
      users.forEach(user => {
        if (!this.userGateLinksByUserId[user.userId]) {
          const userGates = user.gateIds ?? [];
          const gateIdsFromGateData = userGates
            .map(userGate => {
              return this.gates.find(gate =>
                String(gate.id) === String(userGate.gateId) ||
                gate.name === (userGate.abbreviation ?? "")
              )?.id;
            })
            .filter(id => id !== undefined);

          this.userGateLinksByUserId[user.userId] = [
            ...(user.gateIds ?? []),
            ...gateIdsFromGateData
          ].filter(Boolean);
        }
      });
    },

    isGateLinked(userId, gateId) {
      return this.userGateLinksByUserId[userId]
        ?.some(linkedGateId => String(linkedGateId) === String(gateId)) ?? false;
    },

    toggleGateLink(userId, gateId, isLinked) {
      const user = this.userRoles.find(userRole => userRole.userId === userId);

      if (user?.isSelf) {
        return;
      }

      const currentLinks = this.userGateLinksByUserId[userId] || [];

      if (isLinked) {
        if (!currentLinks.some(linkedGateId => String(linkedGateId) === String(gateId))) {
          this.userGateLinksByUserId[userId] = [...currentLinks, gateId];
        }

        return;
      }

      this.userGateLinksByUserId[userId] = currentLinks
        .filter(linkedGateId => String(linkedGateId) !== String(gateId));
    },

    getGateIdsForUser(userId) {
      return this.userGateLinksByUserId[userId] || [];
    },

    mapUserRolesPayload() {
      return this.userRoles.map(user => ({
        ...user,
        gateIds: this.getGateIdsForUser(user.userId)
      }));
    },

    getData() {
      this.isLoading = true;

      Promise.all([
        this.$axiosInstance.get(`${process.env.VUE_APP_API}/UserRoles`),
        this.$axiosInstance.get(`${process.env.VUE_APP_API}/UserRoles/NonAddedUsers`),
        this.$axiosInstance.get(`${process.env.VUE_APP_API}/Gates/Abbreviations`)
      ])
      .then(([userRoles, nonAddedUsers, gateAbbreviations]) => {
        if (!(gateAbbreviations.data === "")) {
          this.gates = gateAbbreviations.data
            .map(this.normalizeGate)
            .filter(gate => gate.name);
        }

        if(!(userRoles.data === ""))
        {
          this.userRoles = userRoles.data;
          this.hydrateGateLinks(this.userRoles);
        }

        if(!(nonAddedUsers.data === "")) {
          this.nonAddedUsers = nonAddedUsers.data;
        }

        this.addToUserRolesId = "";
      })
      .catch(() => {
          this.$toast.open({
            message: 'Gebruiker data kon niet opgehaald worden. Probeer het a.u.b. opnieuw.',
            type: 'error',
            position: 'top-right',
            duration: 5000
          })
      })
      .finally(() => {
        this.isLoading = false;
      })
    },
    addToUserList() {
      const selectedId = this.addToUserRolesId;
      const selectedUser = _.find(this.nonAddedUsers, { userId: selectedId });
      if (selectedUser) {
        selectedUser.role = "Member";

        this.userRoles.push(selectedUser);
        this.hydrateGateLinks([selectedUser]);
        
        _.remove(this.nonAddedUsers, selectedUser => selectedUser.userId === selectedId);

        this.addToUserRolesId = '';
      }
    },

    removeFromUserList(userId) {
      const selectedUser = _.find(this.userRoles, { userId: userId });

      if (!selectedUser || selectedUser.isSelf) {
        return;
      }

      _.remove(this.userRoles, selectedUser);

      delete selectedUser.role;
      delete this.userGateLinksByUserId[userId];

      this.nonAddedUsers.push(selectedUser);
    },

    formSubmit() {
      this.isLoading = true;

      this.$axiosInstance.put(`${process.env.VUE_APP_API}/UserRoles`, this.mapUserRolesPayload())
        .then(() => 
          this.$toast.open({
            message: 'Gebruikers succesvol opgeslagen!',
            position: 'top-right',
            duration: 5000
          })
        )
        .catch(() => {
          this.$toast.open({
            message: 'Opslaan mislukt. Probeer het a.u.b. opnieuw.',
            type: 'error',
            position: 'top-right',
            duration: 5000
          })
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.getData();
    window.addEventListener('resize', this.updateScrollIndicators);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateScrollIndicators);
  },

  updated() {
    this.$nextTick(() => this.updateScrollIndicators());
  }
};
</script>

<style lang="scss" scoped>

.gebruikers-beheer {
  .table-scroll-container {
    position: relative;
  }

  .scroll-indicators {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 0.4rem 0;
  }

  .scroll-hint {
    font-size: 0.8rem;
    color: #888;
  }

  .scroll-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.75rem;
    height: 1.75rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    color: #555;
    font-size: 1.2rem;
    line-height: 1;
    padding: 0;
    background: #f8f9fa;

    &:hover {
      background: #e9ecef;
      color: #000;
    }
  }

  .scroll-indicator-hidden {
    visibility: hidden;
  }

  .user-tabel-wrapper {
    overflow-x: auto;
  }

  .form-group {
    .btn {
      width: 3.3rem;
      text-align: center;
    }
  }

  .user-tabel {
    margin-bottom: 0;
    table-layout: fixed;
    width: max-content;

    th,
    td {
      vertical-align: middle;
      padding: $spacer * 0.75;
    }

    .gebruiker-kolom {
      min-width: 16rem;
    }

    .poort-kolom {
      min-width: 4rem;
      white-space: nowrap;
    }

    .poort-link {
      color: $body-color;
      text-decoration: none;

      &:hover {
        color: $primary-dark;
        text-decoration: underline;
      }
    }

    .poort-cel {
      min-width: 4rem;
      width: 4rem;
    }

    .rol-kolom {
      min-width: 12rem;
    }

    .verwijderen-kolom {
      min-width: 7rem;
    }

    .role-header,
    .rol-kolom {
      right: 7rem;
      z-index: 2;
      background-color: $white;
    }

    .verwijderen-header,
    .verwijderen-kolom {
      right: 0;
      z-index: 3;
      background-color: $white;
    }

    .sticky-column {
      position: sticky;
    }

    .sticky-column-left {
      left: 0;
      z-index: 2;
      background-color: $white;
      box-shadow: 8px 0 12px -12px rgba(0, 0, 0, 0.35);
    }

    .sticky-column-right {
      box-shadow: -8px 0 12px -12px rgba(0, 0, 0, 0.35);
    }

    thead {
      .sticky-column {
        z-index: 4;
      }
    }

    .form-select {
      min-width: 10rem;
    }
    .list-group-item-disabled {
      background-color: #e9ecef;

      .sticky-column-left,
      .role-header,
      .rol-kolom,
      .verwijderen-header,
      .verwijderen-kolom,
      .form-select,
      .form-check-input {
        background-color: #e9ecef;
      }
    }
  }
}

.actions {
  margin-top: $spacer * 1.5;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .btn {
    min-width: 7.5rem;
  }
}

</style>
